// extracted by mini-css-extract-plugin
module.exports =  {"switch":"_93444fe79c--switch--WlT9Z","indicator":"_93444fe79c--indicator--qrsk6","label":"_93444fe79c--label--L_Whq"};